import { API_CODE } from "../../../../../controller/api/constants"
import { getApi, postApi, uploadApi } from "../../../../../controller/api/get"
import { calculateTotalPage, calculatePageToSkipTake } from "../../../../../helper/helper";

export const getSummary = async (cookie, filter) => {
  const requestData = {
    from: filter.from,
    to: filter.to,
    bookPhone: filter.phone,
    bookEmail: filter.email,
    status: filter.status && filter.status.length > 0 ? parseInt(filter.status) : undefined,
    paymentMethod: filter.paymentMethod && filter.paymentMethod.length > 0 ? filter.paymentMethod : undefined,
    id: filter.id,
  }

  const response = await getApi(cookie, API_CODE.GET_CART_SUMMARY, requestData)

  if (response) {
    return {
      count: response.count,
      value: response.value
    }
  }
  return undefined
}

export const getList = async (cookie, filter, page) => {
  const [skip, take] = calculatePageToSkipTake(page)
  const requestData = {
    from: filter.from,
    to: filter.to,
    bookPhone: filter.phone,
    bookEmail: filter.email,
    status: filter.status && filter.status.length > 0 ? parseInt(filter.status) : undefined,
    paymentMethod: filter.paymentMethod && filter.paymentMethod.length > 0 ? filter.paymentMethod : undefined,
    id: filter.id,
    skip: skip,
    take: take,
  }
  const response = await getApi(cookie, API_CODE.GET_CART, requestData)

  if (response) {
    return {
      list: response.list,
      total: response.total,
      totalPage: calculateTotalPage(response.total)
    }
  }
  return undefined
}

export const update = async (cookie, id, action, data) => {
  const requestData = {
    id: id,
    action: action,
    data: data
  }
  const response = await postApi(cookie, API_CODE.POST_UPDATE_CART, requestData)

  return response
}

export const upload = async (name, type, ticket) => {
  const response = await uploadApi(ticket, name, type)

  return response
}

export const sendZNS = async (cookie, id) => {
  const requestData = {
    cartId: id
  }
  const response = await postApi(cookie, API_CODE.POST_SEND_ZNS, requestData)

  return response
}